import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-777489c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "parts-list" }
const _hoisted_2 = { class: "parts-info" }
const _hoisted_3 = { class: "parts-name" }
const _hoisted_4 = { class: "parts-price" }
const _hoisted_5 = { class: "parts-price" }
const _hoisted_6 = { class: "parts-price" }
const _hoisted_7 = {
  key: 0,
  class: "expand-detail xag-flex-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "展开明细", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-down-svg" }, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

import BlockkWrapper from '../block-wrap.vue'
import { ref, computed, withDefaults } from 'vue'
import { MalfunctionRepairRepairOrderMateItem } from '@/types/malfunction-repair'

export default /*#__PURE__*/_defineComponent({
  __name: 'detail-repair-parts-block',
  props: {
    parts: { default: () => [] },
    show: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { parts: MalfunctionRepairRepairOrderMateItem[], show: boolean };


function getInfoImageStyle(url: string) {
  return `background-image: url(${url})`
}
const showNum = ref(2)
const showList = computed(() => {
  return props.parts.slice(0, showNum.value)
})
const showMoreBtn = computed(() => {
  return showList.value.length !== props.parts.length
})
const waitText = computed(() => {
  if (props.show) {
    if (props.parts.length === 0) {
      return '暂无'
    }
    return ''
  }
  return '待定损'
})
function showMore() {
  showNum.value = props.parts.length
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlockkWrapper, {
    title: "维修配件",
    waitText: _unref(waitText)
  }, {
    default: _withCtx(() => [
      (props.show)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("ul", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(showList), (part) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "parts-item xag-flex",
                  key: part.material_code
                }, [
                  _createElementVNode("div", {
                    class: "parts-img",
                    style: _normalizeStyle(getInfoImageStyle(part.image))
                  }, null, 4),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("p", _hoisted_3, _toDisplayString(part.material_name), 1),
                    _createElementVNode("div", _hoisted_4, "×" + _toDisplayString(`${part.num}${part.shortage_loss_num? `(暂缺 ${part.shortage_loss_num})`:''}`), 1),
                    _createElementVNode("p", _hoisted_5, " 配件费 ￥" + _toDisplayString(part.discount_price) + " (原价￥" + _toDisplayString(part.raw_price) + " 抵扣￥ " + _toDisplayString(part.discount_amount) + ") ", 1),
                    _createElementVNode("p", _hoisted_6, " 工时费 ￥" + _toDisplayString(part.discount_hourly_price) + " (原价￥" + _toDisplayString(part.raw_hourly_price) + " 抵扣￥" + _toDisplayString(part.hourly_discount_amount) + ") ", 1)
                  ])
                ]))
              }), 128))
            ]),
            (_unref(showMoreBtn))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: "xag-flex-center",
                    onClick: showMore
                  }, _hoisted_10)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["waitText"]))
}
}

})